import Catagories from "./catagories";
import Items from "./data";
import Menu from "./menu";
import React, { useState } from "react";

function App() {
  const [menu, setMenu] = useState(Items);

  const uniqueItems = ["all", ...new Set(Items.map((item) => item.category))];
  const [categories, setCatagories] = useState(uniqueItems);

  const filterItems = (category) => {
    if (category === "all") {
      setMenu(Items);
      return;
    }
    const newItems = Items.filter((item) => item.category === category);
    setMenu(newItems);
  };

  return (
    <section className="section menu">
      <h2 className="title">Menu</h2>
      <div className="underline"></div>
      <hr />
      <Catagories categories={categories} filterItems={filterItems} />
      <Menu items={menu} />
    </section>
  );
}

export default App;
